// extracted by mini-css-extract-plugin
export var error = "MailchimpForm-module--error--Ikr9H";
export var form = "MailchimpForm-module--form--j2ROq";
export var input = "MailchimpForm-module--input--ympCn";
export var submit = "MailchimpForm-module--submit--DcTbE";
export var subtitle = "MailchimpForm-module--subtitle--OSYs+";
export var text = "MailchimpForm-module--text--fXwC1";